/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WalletEphemeralKeyResponse } from '../models/WalletEphemeralKeyResponse';
import type { WalletPaymentMethodsResponse } from '../models/WalletPaymentMethodsResponse';
import type { WalletResponse } from '../models/WalletResponse';
import type { WalletSetupIntentResponse } from '../models/WalletSetupIntentResponse';
import type { WalletStatusResponse } from '../models/WalletStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WalletService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the authenticated user's wallet
     * Returns the Stripe account details for the authenticated user. Works for both clients (Stripe Customer) and society owners (Stripe Connect Account). Returns null data if no wallet exists yet.
     * @returns WalletResponse Wallet details returned successfully.
     * @throws ApiError
     */
    public walletControllerGetWallet(): CancelablePromise<WalletResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * Create a wallet for the authenticated user
     * Creates a Stripe customer (for clients) or Connect account (for society owners) and links it to their profile. Returns the wallet details after creation.
     * @returns WalletResponse Wallet created successfully.
     * @throws ApiError
     */
    public walletControllerCreateWallet(): CancelablePromise<WalletResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/wallet',
            errors: {
                400: `Bad request. User type not supported or society not found.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or SOCIETY_OWNER role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Get wallet readiness status
     * Returns whether the wallet is ready to receive splits and lists any missing requirements. For society owners, checks Stripe Connect account status. For clients, always returns ready.
     * @returns WalletStatusResponse Wallet status returned successfully.
     * @throws ApiError
     */
    public walletControllerGetStatus(): CancelablePromise<WalletStatusResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/status',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or SOCIETY_OWNER role required.`,
            },
        });
    }
    /**
     * Create a SetupIntent for saving a payment method
     * Returns a Stripe SetupIntent client secret for the Flutter Stripe SDK. The user must have a wallet (Stripe customer) first.
     * @returns WalletSetupIntentResponse SetupIntent created successfully.
     * @throws ApiError
     */
    public walletControllerCreateSetupIntent(): CancelablePromise<WalletSetupIntentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/wallet/setup-intent',
            errors: {
                400: `Bad request. Setup intents only available for clients.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `No wallet found. Create a wallet first.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Create an ephemeral key for CustomerSheet
     * Returns a Stripe ephemeral key secret and customer ID for use with the Flutter Stripe SDK CustomerSheet.
     * @returns WalletEphemeralKeyResponse Ephemeral key created successfully.
     * @throws ApiError
     */
    public walletControllerCreateEphemeralKey(): CancelablePromise<WalletEphemeralKeyResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/wallet/ephemeral-key',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * List saved payment methods
     * Returns all saved card payment methods for the authenticated client's wallet.
     * @returns WalletPaymentMethodsResponse Payment methods returned successfully.
     * @throws ApiError
     */
    public walletControllerListPaymentMethods(): CancelablePromise<WalletPaymentMethodsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/wallet/payment-methods',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                501: `Stripe integration not configured.`,
            },
        });
    }
    /**
     * Set a payment method as default
     * Sets the specified payment method as the default for the authenticated client.
     * @returns any Default payment method updated successfully.
     * @throws ApiError
     */
    public walletControllerSetDefaultPaymentMethod({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/wallet/payment-methods/{id}/set-default',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Payment method not found.`,
            },
        });
    }
    /**
     * Delete a payment method
     * Detaches the specified payment method from the Stripe customer. If it was the default, clears the default.
     * @returns any Payment method deleted successfully.
     * @throws ApiError
     */
    public walletControllerDeletePaymentMethod({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/wallet/payment-methods/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Payment method not found.`,
            },
        });
    }
}
